import { render, staticRenderFns } from "./ResultForm.vue?vue&type=template&id=21462def"
import script from "./ResultForm.vue?vue&type=script&lang=js"
export * from "./ResultForm.vue?vue&type=script&lang=js"
import style0 from "./ResultForm.vue?vue&type=style&index=0&id=21462def&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports